module.exports = __webpack_public_path__ + "img/zapier.11429a35.png";